import { createSelector } from "reselect";
import { isEmpty, forIn, isNull } from "lodash";

//EXTRACT THE PART OF THE STATE
const getData = state => state.user.profile;

//VERIFY IF THE JWT IS SET
const getMyUserProfileRaw = createSelector(getData, userProfile => userProfile);
export default getMyUserProfileRaw;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMyUserProfileRaw.js